import React, { FC, ReactNode } from 'react'
import { RequiredTag } from '../common/RequiredTag'

interface FormFieldProps {
  label: string
  labelClassName?: string
  required?: boolean
  description?: string
  children: ReactNode
  className?: string
  showTag?: boolean
  error?: string
}

export const FormField: FC<FormFieldProps> = ({
  label,
  labelClassName,
  required = false,
  description,
  children,
  className = '',
  showTag = true,
  error,
}) => {
  return (
    <div className={`py-2 ${error ? 'has-error' : ''} ${className}`}>
      <div className="flex justify-start">
        <label className={labelClassName || 'whitespace-nowrap font-bold pr-4'}>
          {label}
        </label>
        {showTag && <RequiredTag required={required} />}
      </div>
      <div className="mt-1">{children}</div>
      {description && (
        <p className="text-gray-400 text-sm py-2">{description}</p>
      )}
      {error && <p className="text-main-red text-sm mt-1">{error}</p>}
    </div>
  )
}
